module.exports = __webpack_public_path__ + "static/img/nav5.d892dd03.png";